import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../form/Form";
import { Input } from "./Input";
import { useFormContext } from "react-hook-form";
import FormRequiredLabel from "../label/FormRequiredLabel";

const FormInput = ({
  name,
  label,
  placeholder,
  type = "text",
  required = false,
  disabled = false,
}) => {
  const { control } = useFormContext();

  return (
    <div>
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {required ? (
              <FormRequiredLabel text={label} />
            ) : (
              <FormLabel>{label}</FormLabel>
            )}
            <FormControl>
              <Input
                {...field}
                type={type}
                placeholder={placeholder}
                disabled={disabled}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      ></FormField>
    </div>
  );
};

export default FormInput;
